import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';

const usePortfolioAnalytics = () => {
    const sendTrackEvent = (ga: { action: string; category?: string; label?: string }) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: 'Portfolio',
            category: 'Portfolio',
            app: AppName.PORTFOLIO_SUMMARY,
        });
    };

    const trackFrameworkClick = () => {
        sendTrackEvent({
            action: `portfolio_framework_click`,
        });
    };

    const trackEditObjectiveClick = () => {
        sendTrackEvent({
            action: `portfolio_edit_objective_save_click`,
        });
    };

    const trackExploreClick = (params: { section: string }) => {
        sendTrackEvent({
            action: `portfolio_${params.section}_explore_click`,
        });
    };

    const trackExplainerHover = (params: { slug: string }) => {
        sendTrackEvent({
            action: `portfolio_explainer_hover`,
            label: params.slug,
        });
    };

    const trackDetailedExplainerClick = (params: { slug: string }) => {
        sendTrackEvent({
            action: `portfolio_detailed_explainer_click`,
            label: params.slug,
        });
    };

    const trackLandCoverPeriodChange = (period: string) => {
        sendTrackEvent({
            action: 'portfolio_land_cover_period_change',
            label: period,
        });
    };

    const trackHabitatBaselineChange = (baselineYear: string) => {
        sendTrackEvent({
            action: 'portfolio_habitat_baseline_change',
            label: baselineYear,
        });
    };

    return {
        sendTrackEvent,
        trackFrameworkClick,
        trackEditObjectiveClick,
        trackExploreClick,
        trackExplainerHover,
        trackDetailedExplainerClick,
        trackLandCoverPeriodChange,
        trackHabitatBaselineChange,
    };
};

export default usePortfolioAnalytics;
